import React from 'react';
import { PropTypes as PT } from 'prop-types';
import ReactSpinner from 'react16-spinjs';
import ButtonComp from 'components/Button/Button';
import { FormattedMessage, injectIntl } from 'react-intl';
import classes from './DeleteContact.module.scss';

const resetButton = (<FormattedMessage
  id="cancel"
  defaultMessage="Cancel"
/>);

class DeleteContact extends React.PureComponent {
  handleDelete = () => {
    this.props.deleteContact(this.props.contact);
  };

  render = () => {
    const {
      handleCancel,
      deleting,
      deleteError
    } = this.props;

    return (
      <div className={classes.container}>
        {deleteError && <div className={classes.errorMessage}>
          <FormattedMessage
            id="deleteError"
            defaultMessage="Unable to delete contact."
          />
        </div>}
        <div className={classes.buttonBar}>
          <ButtonComp
            kind="secondary"
            onClick={handleCancel}
            disabled={deleting}
            dataAttrs={{ 'data-testid': 'cancel-btn' }}
          >
            {resetButton}
          </ButtonComp>
          <ButtonComp
            kind="primary"
            onClick={this.handleDelete}
            disabled={deleting}
            dataAttrs={{ 'data-testid': 'delete-btn' }}
          >
            {deleting ?
              <ReactSpinner
                config={{
                  lines: 13,
                  length: 5,
                  width: 3,
                  radius: 5,
                  color: '#fff',
                  speed: 0.7
                }}
              />
              :
              <FormattedMessage
                id="delete"
                defaultMessage="Delete"
              />
            }
          </ButtonComp>
        </div>
      </div>
    );
  }
}

DeleteContact.propTypes = {
  deleteContact: PT.func.isRequired,
  handleCancel: PT.func.isRequired,
  contact: PT.object.isRequired,
  deleting: PT.bool,
  deleteError: PT.string
};

export default injectIntl(DeleteContact);
